import type { IDataViewFiltersLabels, IDataViewHeaderConfig } from '@/domains/investor/components/DataView/DataView.types'

export const REPORTS_FILTERS_LABELS: IDataViewFiltersLabels = {
  categoryLabel: 'investor.reports.dataView.filters.category.label',
  searchLabel: 'investor.reports.search.label',
  searchPlaceholder: 'investor.reports.search.placeholder',
  searchSubmit: 'investor.reports.search.submit',
  yearLabel: 'investor.reports.dataView.filters.year.label',
  yearPlaceholder: 'investor.reports.dataView.filters.year.placeholder',
  monthLabel: 'investor.reports.dataView.filters.month.label',
  monthPlaceholder: 'investor.reports.dataView.filters.month.placeholder',
  resultsLabel: 'investor.reports.results.label',
  resultsUnit: 'investor.reports.results.unit',
  clearFilters: 'investor.reports.filters.clear',
}

export const REPORTS_HEADER_CONFIG: IDataViewHeaderConfig = {
  text: 'investor.reports.title',
  size: 'h5',
  position: 'center',
}
